import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { FormField, withForm, SidePageV2 } from '@gogame/form';

export const NAME = 'name';

const OutsourceStudioForm = withForm({
  enableReinitialize: true,
})(({ title, values, submitForm, onClose, onExited, open, loading }) => {
  return (
    <SidePageV2
      title={title}
      onClose={onClose}
      onExited={onExited}
      open={open}
      size={'sm'}
      loading={loading}
    >
      <SidePageV2.Title title={title} withoutClose={true} />
      <SidePageV2.NewBody scroll={false}>
        <FormField.TextField name={NAME} label={'Name'} required={true} />
      </SidePageV2.NewBody>
      <SidePageV2.Actions>
        <SidePageV2.CloseButton />
        <SidePageV2.SubmitButton
          disabled={isEmpty(values.name)}
          onSubmit={submitForm}
        />
      </SidePageV2.Actions>
    </SidePageV2>
  );
});

export default OutsourceStudioForm;
